/** In-app Support Desk (slice 1). Spec: docs/support-desk/INTAKE-SPEC-GAP.md */
export const supportDeskConfig = {
  enabled: true,
  supportPath: '/support',
  supportIntakeHash: 'support-desk',
}
